// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extract-section{
    padding: 15px 10px;
}

.extract-section .search-btn {
    background-color: var(--main-color);
    border: none;
    width: 120px;
    border-radius: 22px;
    margin-left: -28px;
    color: white;
    cursor: pointer;
    font-weight: bold;
    height: 36px;
    transition: var(--main-transition);
}

.extract-section .search-btn:hover{
    background-color: #0876f5;
}


/* For Start Extract Search Page  */
.extract-section .page-search-section .search-items form .search-bar{
    background-color: white;
    width: 400px;
    max-width: 100%;
    padding: 3px 14px;
    border-radius:22px;
    
}

.extract-section .page-search-section .search-items form{
    display: flex;
}

.extract-section .page-search-section .search-items form .search-bar input{
    width: calc(100% - 32px);
    border: none;
    color: var(--gray-color);
    font-size: 15px;
}

.extract-section .page-search-section .search-items form .search-bar input:focus{
    outline: none;
}

.extract-section .page-search-section .search-items form .search-bar svg{
    color: var(--gray-color);
    margin:0px 8px;
}

.extract-section .page-search-section .search-items form button{
    background-color: var(--main-color);
    padding: 8px 27px ;
    border-radius: 22px;
    color: white;
    font-weight: bold;
    margin: 0px 6px;
    border: none;
    cursor: pointer;
}



.extract-section .main-pagination{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 650px;
}

.extract-section .main-pagination .pagination-btn{
    width: 100px;
    margin: 10px 0px;
}

.extract-section .main-pagination .pagination-btn button{
    color: white;
    background-color: var(--main-color); 
    border-radius: 22px;
    cursor: pointer;
    padding: 10px 22px;
    border: none;
}


/* For End Extract Search Page  */`, "",{"version":3,"sources":["webpack://./src/Pages/ExtractData/extrac.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,mCAAmC;AACnC;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;;AAGA,iCAAiC","sourcesContent":[".extract-section{\n    padding: 15px 10px;\n}\n\n.extract-section .search-btn {\n    background-color: var(--main-color);\n    border: none;\n    width: 120px;\n    border-radius: 22px;\n    margin-left: -28px;\n    color: white;\n    cursor: pointer;\n    font-weight: bold;\n    height: 36px;\n    transition: var(--main-transition);\n}\n\n.extract-section .search-btn:hover{\n    background-color: #0876f5;\n}\n\n\n/* For Start Extract Search Page  */\n.extract-section .page-search-section .search-items form .search-bar{\n    background-color: white;\n    width: 400px;\n    max-width: 100%;\n    padding: 3px 14px;\n    border-radius:22px;\n    \n}\n\n.extract-section .page-search-section .search-items form{\n    display: flex;\n}\n\n.extract-section .page-search-section .search-items form .search-bar input{\n    width: calc(100% - 32px);\n    border: none;\n    color: var(--gray-color);\n    font-size: 15px;\n}\n\n.extract-section .page-search-section .search-items form .search-bar input:focus{\n    outline: none;\n}\n\n.extract-section .page-search-section .search-items form .search-bar svg{\n    color: var(--gray-color);\n    margin:0px 8px;\n}\n\n.extract-section .page-search-section .search-items form button{\n    background-color: var(--main-color);\n    padding: 8px 27px ;\n    border-radius: 22px;\n    color: white;\n    font-weight: bold;\n    margin: 0px 6px;\n    border: none;\n    cursor: pointer;\n}\n\n\n\n.extract-section .main-pagination{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 650px;\n}\n\n.extract-section .main-pagination .pagination-btn{\n    width: 100px;\n    margin: 10px 0px;\n}\n\n.extract-section .main-pagination .pagination-btn button{\n    color: white;\n    background-color: var(--main-color); \n    border-radius: 22px;\n    cursor: pointer;\n    padding: 10px 22px;\n    border: none;\n}\n\n\n/* For End Extract Search Page  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
